import type { LocalTimeValue } from '../../../types/form/form-fields/field-values';
import type { ConstraintFunction } from '../../../types/form/form-section/config';

// Enum for time picker units (MINUTES, HOURS)
export enum TimeUnit {
	MINUTES = 'minutes',
	HOURS = 'hours',
}

export const timeValueEqualToCheck: ConstraintFunction<LocalTimeValue> = (
	value: LocalTimeValue | undefined,
	constraint: string[],
) => value !== undefined && value.localTime === constraint[0];

export const timeValueDoesNotEqualToCheck: ConstraintFunction<LocalTimeValue> = (
	value: LocalTimeValue | undefined,
	constraint: string[],
) => value === undefined || value.localTime !== constraint[0];

export const timeValueGreaterThanCheck: ConstraintFunction<LocalTimeValue> = (
	value: LocalTimeValue | undefined,
	constraint: string[],
) => value !== undefined && value.localTime > constraint[0];

export const timeValueGreaterThanOrEqualToCheck: ConstraintFunction<LocalTimeValue> = (
	value: LocalTimeValue | undefined,
	constraint: string[],
) => value !== undefined && value.localTime >= constraint[0];

export const timeValueLessThanCheck: ConstraintFunction<LocalTimeValue> = (
	value: LocalTimeValue | undefined,
	constraint: string[],
) => value !== undefined && value.localTime < constraint[0];

export const timeValueLessThanOrEqualToCheck: ConstraintFunction<LocalTimeValue> = (
	value: LocalTimeValue | undefined,
	constraint: string[],
) => value !== undefined && value.localTime <= constraint[0];

// BETWEEN: Inclusive of minimum and maximum
export const timeValueBetweenCheck: ConstraintFunction<LocalTimeValue> = (
	value: LocalTimeValue | undefined,
	constraint: string[],
) => {
	if (value === undefined) {
		return false;
	}
	const min = constraint[0];
	const max = constraint[1];
	return value.localTime >= min && value.localTime <= max;
};

export const timeValueEmptyCheck: ConstraintFunction<LocalTimeValue> = (
	value: LocalTimeValue | undefined,
) => value === undefined || !value.localTime;

export const timeValueNotEmptyCheck: ConstraintFunction<LocalTimeValue> = (
	value: LocalTimeValue | undefined,
) => value !== undefined && !!value.localTime;
